import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-sidebar__wrapper" }
const _hoisted_2 = { class: "c-sidebar__logo-wrapper" }
const _hoisted_3 = { class: "c-sidebar__user-welcome" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "o-separator c-sidebar__only-mobile" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "o-separator c-sidebar__only-mobile" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheLogo = _resolveComponent("TheLogo")!
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!
  const _component_TheButton = _resolveComponent("TheButton")!
  const _component_LanguageSelect = _resolveComponent("LanguageSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-sidebar", { 'c-sidebar--expanded': _ctx.isExpanded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TheLogo, {
          class: "c-sidebar__logo",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeMenu('/')), ["prevent"]))
        })
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('SIDEBAR_WELCOME')) + " " + _toDisplayString(_ctx.userName) + "! 👋 ", 1),
      _hoisted_4,
      _createVNode(_component_SidebarMenu, {
        class: "c-sidebar__menu",
        onCloseMenu: _ctx.closeMenu
      }, null, 8, ["onCloseMenu"]),
      _hoisted_5,
      _createVNode(_component_TheButton, {
        to: "/settings",
        class: "c-sidebar__settings",
        icon: "IconSettings"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('SIDEBAR_SETTINGS')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LanguageSelect, {
        "language-list": _ctx.languageList,
        currentLanguage: _ctx.currentLanguage,
        canClear: false,
        canDeselect: false,
        onLanguageChange: _ctx.onLanguageChange
      }, null, 8, ["language-list", "currentLanguage", "onLanguageChange"]),
      _createVNode(_component_TheButton, {
        class: "c-sidebar__logout",
        icon: "IconLogout",
        onClick: _ctx.logout
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('LOGOUT')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 2))
}